module.exports = __webpack_public_path__ + "img/invest_plan_1.62438488.svg";